import React from 'react';
import { Loader, Segment, Dimmer,Image} from "semantic-ui-react";
import {Auth} from 'aws-amplify';



function Loader1(){
  return (
	<div>
		<Segment>
		      <Dimmer active inverted>
		        <Loader size='massive'>Loading</Loader>
		      </Dimmer>
		
		      <Image src='./paragraph.png' />
		</Segment>
	</div>
	)
}

export default Loader1;